<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="size"
         :height="size"
         viewBox="0 0 24 24"
         fill="none"
         :stroke="color"
         stroke-width="2.5"
         stroke-linecap="square"
         stroke-linejoin="round"><path d="M15.6 11.6L22 7v10l-6.4-4.5v-1zM4 5h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2z"/></svg>
</template>
<script>
    export default {
        props: {
            size: { type: [String, Number], default: 22 },
            color: { type: String, default: 'white' }
        }
    }
</script>
